import request from '../../../helpers/request';

const deleteRoom = async (id) => {
  await request.delete(
    `/RentPlace/rental_house/office/${id}`,
    {},
    'При удалении помещения произошла ошибка'
  );
};

export default deleteRoom;
